export const CONFIG = {
	IS_TEST: false,
};
